<!-- ActionBar.vue -->
<template>
  <transition
    enter-active-class="tw-transition tw-duration-300 tw-ease-out tw-transform"
    enter-from-class="tw-opacity-0 tw-translate-y-4"
    enter-to-class="tw-opacity-100 tw-translate-y-0"
    leave-active-class="tw-transition tw-duration-200 tw-ease-in tw-transform"
    leave-from-class="tw-opacity-100 tw-translate-y-0"
    leave-to-class="tw-opacity-0 tw-translate-y-4"
  >
    <div
      v-if="!hide"
      v-bind="$attrs"
      class="tw-flex tw-shadow-lg tw-px-4 tw-bg-white tw-rounded-lg tw-fixed tw-bottom-9 tw-h-[60px]"
      :style="`width: ${width}; zIndex: ${zIndex}`"
    >
      <slot />
    </div>
  </transition>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    hide?: boolean
    width?: string
    zIndex?: number | string
  }>(),
  {
    hide: false,
    width: '100%',
    zIndex: 9,
  },
)
</script>
